(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gemstone-recommendations"] && !Shopify.designMode) return;
  try {
    
  var dialCode = '+91',
    phone,
    ajaxMessage = '.ajax-message',
    phoneNumber,
    otpNumber = '3456',
    sendOtp = true,
    submitBtn = $('.rudraksh').find('[type=submit]');
  var FORM_STORAGE_KEY = 'brahmagems_form_draft';

  function saveFormToStorage() {
    var $form = $('#ajax-form');
    if (!$form.length) return;
    var fullPhone = '';
    try {
      if ($('.phone-intl').length) fullPhone = $('.phone-intl').intlTelInput('getNumber') || '';
    } catch (e) {}
    if (!fullPhone) fullPhone = dialCode + ($('[name="phone"]').val() || '');
    var data = {
      name: $form.find('[name="name"]').val() || '',
      email: $form.find('[name="email"]').val() || '',
      phone: fullPhone || '',
      date_of_birth: $form.find('[name="date_of_birth"]').val() || '',
      time_of_birth: $form.find('[name="time_of_birth"]').val() || '',
      place_of_birth: $form.find('[name="place_of_birth"]').val() || '',
    };
    try {
      localStorage.setItem(FORM_STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function loadFormFromStorage() {
    var saved;
    try {
      saved = localStorage.getItem(FORM_STORAGE_KEY);
      if (!saved) return;
      saved = JSON.parse(saved);
    } catch (e) {
      return;
    }
    var $form = $('#ajax-form');
    if (!$form.length) return;
    if (saved.name) $form.find('[name="name"]').val(saved.name);
    if (saved.email) $form.find('[name="email"]').val(saved.email);
    if (saved.date_of_birth) $form.find('[name="date_of_birth"]').val(saved.date_of_birth);
    if (saved.time_of_birth) $form.find('[name="time_of_birth"]').val(saved.time_of_birth);
    if (saved.place_of_birth) $form.find('[name="place_of_birth"]').val(saved.place_of_birth);
    if (saved.phone && $('.phone-intl').length) {
      try {
        $('.phone-intl').intlTelInput('setNumber', saved.phone);
      } catch (e) {
        $form.find('[name="phone"]').val(saved.phone.replace(/^\+\d+/, ''));
      }
    }
  }

  $('.phone-intl')
    .intlTelInput({
      initialCountry: 'in',
      separateDialCode: true,
    })
    .on('countrychange', function (e, countryData) {
      dialCode = '+' + $(this).intlTelInput('getSelectedCountryData').dialCode;
    });

  $(function () {
    loadFormFromStorage();
  });

  $('body').on('input change', '#ajax-form input', function () {
    saveFormToStorage();
  });

  document.addEventListener('DOMContentLoaded', function () {
    const inputs = document.querySelectorAll('#otp > input');
    for (let i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener('input', function () {
        if (this.value.length > 1) {
          this.value = this.value[0]; //
        }
        if (this.value !== '' && i < inputs.length - 1) {
          inputs[i + 1].focus(); //
        }
        getOTPNumber();
      });

      inputs[i].addEventListener('keydown', function (event) {
        if (event.key === 'Backspace') {
          this.value = '';
          if (i > 0) {
            inputs[i - 1].focus();
          }
        }
        getOTPNumber();
      });
    }

    function getOTPNumber() {
      otpNumber = '';
      inputs.forEach((input) => {
        otpNumber += input.value;
      });
    }
  });

  $('[name="phone"]').on('keyup', function () {
    let value = $(this).val(
      $(this)
        .val()
        .replace(/^0*(.+)/, '$1')
    );
    if (phoneNumber == $(this).val() && phoneNumber != '') {
      sendOtp = true;
      submitBtn.val('Verify OTP & Get Recommendation');
    } else {
      submitBtn.val('Submit');
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    const dobInput = document.querySelector('[name="date_of_birth"]');
    const today = new Date().toISOString().split('T')[0];
    dobInput.max = today;
  });

  $('#ajax-form').validate({
    rules: {
      phone: {
        required: true,
      },
      name: {
        required: true,
      },
      email: {
        required: true,
        email: true,
      },
      gender: {
        required: true,
      },
      purpose: {
        required: true,
      },
      body_weight: {
        required: true,
      },
      budget: {
        required: true,
      },
      time_of_birth: {
        required: true,
      },
      date_of_birth: {
        required: true,
      },
      place_of_birth: {
        required: true,
      },
    },
    messages: {
      name: 'Please enter name',
      phone: 'Please enter phone number',
      time_of_birth: 'Please enter time of birth ',
      date_of_birth: 'Please enter date of birth ',
      place_of_birth: 'Please enter place of birth ',
      gender: 'Please enter gender. ',
      purpose: 'Please select purpose. ',
      body_weight: 'Please enter body weight. ',
      budget: 'Please select budget. ',
      email: {
        required: 'Please registered email id',
        email: 'Please enter valid email id',
      },
    },
    errorPlacement: function (error, element) {
      var placement = $(element).data('error');
      if (placement) {
        $(placement).html(error);
      } else {
        error.insertAfter(element);
      }
    },
    submitHandler: function (form) {
      $(this).find('[type=submit]').attr('disabled', '');
      let formdata = new FormData(form);
      formdata.append('phone_code', dialCode);
      formdata.append('otp', otpNumber);
      formdata.append('current_url', window.location.href);
      let phone = $('[name="phone"]').val();

      if (dialCode == '+91') {
        if (phone.length != 10) {
          $('.ajax-message').html('<div class="alert alert-danger">Please enter 10 digits phone number.</div>');
          return false;
        }
      } else {
        if (phone.length > 15) {
          $('.ajax-message').html('Please enter valid phone number.');
          return false;
        } else if (phone.length < 2) {
          $('.ajax-message').html('Please enter valid phone number.');
          return false;
        }
      }

      // if (phoneNumber != phone) {
      //     sendOtp = false;
      // }

      phoneNumber = phone;

      $.ajax({
        url: 'https://api.brahmagems.com/shopify/brahmagems/' + (sendOtp ? 'verify' : 'send') + '-otp',
        type: 'POST',
        data: formdata,
        contentType: false,
        processData: false,
        beforeSend: function () {
          $(ajaxMessage).html(
            '<div class="alert alert-success"><i class="fa fa-refresh fa-spin"></i> Please wait... </div>'
          );
        },
        success: function (res) {
          var apiGems = res.data && res.data.gems ? res.data.gems : [];
          var userName = res.data && res.data.name ? res.data.name : '';
          const gemLabels = [
            'HEALTHY STONE',
            'BENEFITS STONE',
            'LUCKY STONE', // For all remaining gems beyond index 2
          ];
          fetch(window.recommendationUrl)
            .then(function (resp) {
              return resp.json();
            })
            .then(function (themeGems) {
              var byHandle = {};
              (themeGems || []).forEach(function (g) {
                if (g && g.handle) byHandle[g.handle] = g;
              });
              var indexNumber = 0;
              var merged = apiGems
                .map(function (apiGem) {
                  var handle = apiGem.handle || (apiGem.gem_key || '').replace(/_/g, '-');
                  var theme = byHandle[handle];
                  if (!theme) return null;
                  return {
                    name: `${gemLabels[indexNumber++]}: ${theme.name}`,
                    image: theme.image,
                    url: theme.url,
                    wear_day: apiGem.wear_day,
                  };
                })
                .filter(Boolean);
              localStorage.setItem('gems', JSON.stringify(merged));
              localStorage.setItem('name', userName);
              showRecommendation();
            })
            .catch(function () {
              localStorage.setItem('gems', JSON.stringify(apiGems));
              localStorage.setItem('name', userName);
              showRecommendation();
            });
          // $(ajaxMessage).html('<div class="alert alert-success">' + res.message + '</div>');
          // $(".otp-box").show();
          // submitBtn.val('Verify OTP & Get Recommendation');
          // if(sendOtp){
          //   submitBtn[0].reset();
          // }
          // submitBtn[0].reset();
          // sendOtp = true;
        },
        complete: function () {
          submitBtn.removeAttr('disabled');
          setTimeout(function () {
            $(ajaxMessage).html('');
          }, 20000);
        },
        error: function (error) {
          let data = JSON.parse(error.responseText);
          if (error.status === 422) {
            var errorString = '<ul class="ps-3 m-0">';
            $.each(data.errors, function (key, value) {
              errorString += '<li>' + value + '</li>';
            });
            errorString += '</ul>';
            response = errorString;
          } else {
            response = data.error;
          }

          $(ajaxMessage).html('<div class="alert alert-danger">' + response + '</div>');
        },
      });
      return false;
    },
  });

  var DEFAULT_HEADING_HTML = 'Know your <b>Gemstone</b>';

  $('body').on('click', '.edit-form', function (e) {
    e.preventDefault();
    $('#recommendations-view').hide();
    $('#form-view').show();
    var heading = document.getElementById('dynamic-heading');
    if (heading) heading.innerHTML = DEFAULT_HEADING_HTML;
  });

  function showRecommendation() {
    let gems = localStorage.getItem('gems');
    let name = localStorage.getItem('name');

    if (!gems || !name) return;

    // ✅ HEADING REPLACE HERE
    const heading = document.getElementById('dynamic-heading');
    if (heading) {
      heading.innerHTML = `
          Hello <strong>${name}</strong> !<br>
          <span style="font-size:14px; font-family:Montserrat,sans-serif;">
            Here are your recommended gemstones
            <a href="#" class="edit-form ms-2">Edit details</a>
          </span>
        `;
    }

    $('#form-view').hide();
    gems = JSON.parse(gems);

    // function showRecommendation() {
    //     let gems = localStorage.getItem('gems');
    //     let name = localStorage.getItem('name');

    //     if (!gems) return;

    //     $("#ajax-form").hide();

    //     gems = JSON.parse(gems);

    let recommendation = ``;

    //         recommendation += `
    //   <p class="text-center">
    //     Hello <strong>${name}</strong> ! <br>
    //     Here are your recommended gemstones.
    //     <a href="#" class="edit-form fs-sm ms-2">Edit details</a>
    //   </p>
    // `;

    // recommendation += `<p class="text-center">Hello <b>${name}</b>, here are your recommended gems. &nbsp;&nbsp;&nbsp;&nbsp;<a href="" class="edit-form fs-sm">Edit details</a></p> `;
    recommendation += `<div class="row g-4 d-none d-md-flex">`;

    Object.values(gems).forEach((gem) => {
      // FIXED HERE
      recommendation += `
                <div class="col-6 col-md-4 text-center">
                    <a href="${gem.url}" class="category-item">
                        <div class="category-image">
                            <img src="${gem.image}" alt="${gem.name}" loading="lazy">
                        </div>
                        <p class="category-title">${gem.name}</p>
                        <p class="wear-text">Wear: ${gem.wear_day}</p>
                    </a>
                </div>
            `;
    });

    recommendation += `</div>`;

    $('#recommendations-view').html(recommendation).show();
  }

  showRecommendation();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
async function loadWishlist() {
  const container = document.getElementById('product-grid');
  const handles = Wishlist.get();

if (!handles.length && navigator.onLine) {
  container.innerHTML = `
    <li class="col-span-full relative mx-auto mb-5">

      <div class="absolute inset-0 flex items-center justify-center">

        <div class="flex flex-col items-center gap-6 text-center">

          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round"
            class="w-16 h-16 opacity-50">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
          </svg>

          <h2 class="text-2xl font-medium">Your wishlist is empty.</h2>
          <p class="opacity-70">Start adding products you love to your wishlist!</p>

        </div>

      </div>

    </li>
  `;
  return;
}

  container.innerHTML = '';

  for (const handle of handles) {
    try {
      const res = await fetch(`/products/${handle}?section_id=product-card`);
      if (!res.ok) throw new Error('Section failed');

      const html = await res.text();

      // Shopify section returns wrapper div → extract li
      const temp = document.createElement('div');
      temp.innerHTML = html;

      

      temp.querySelectorAll('li').forEach(li => {
         li.querySelectorAll('button, .card__button, .quick-add, .product-form').forEach(el => {
          el.remove();
        });

        // --- remove btn 
   
   const addToCartBtn = document.createElement('button');
addToCartBtn.className = 'wishlist-add-to-cart-btn';
addToCartBtn.innerHTML = '<span>Add to Cart</span>';


addToCartBtn.onclick = async function(e) {
    e.preventDefault();
    addToCartBtn.innerText = 'Adding...';
    
    try {
        const res = await fetch(`/products/${handle}.js`);
        const product = await res.json();
        const variantId = product.variants[0].id;

        const cartRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });

        if (cartRes.ok) {
            addToCartBtn.innerText = 'Added! ✅';
            window.location.href = '/cart'; // Seedha cart page le jao
        }
    } catch (err) {
        addToCartBtn.innerText = 'Error!';
        console.error(err);
    }
};

// --- 2. REMOVE BUTTON (Aapka Exact Code) ---
const removeBtn = document.createElement('button');
removeBtn.className = 'wishlist-remove-btn';
removeBtn.innerHTML = '<span>Remove</span>';




removeBtn.onclick = function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    if (typeof Wishlist !== 'undefined') {
        let items = Wishlist.get().filter(item => item !== handle);
        Wishlist.save(items);

       
        const countBubbles = document.querySelectorAll('.wishlist-count');
        countBubbles.forEach(bubble => {
            bubble.innerText = items.length;
            if (items.length === 0) {
                bubble.style.display = 'none';
            }
        });

   
        li.style.transition = 'all 0.3s ease';
        li.style.opacity = '0';
        setTimeout(() => {
            li.remove();
            if (items.length === 0) location.reload();
        }, 300);
    }
};


const cardMain = li.querySelector('.card');
if (cardMain) {
    cardMain.appendChild(addToCartBtn); 
    cardMain.appendChild(removeBtn);    
} else {
    li.appendChild(addToCartBtn);
    li.appendChild(removeBtn);
}
    
    // --- remove btn  end hare  
        
        container.appendChild(li);

        
      });

    } catch (e) {
      console.warn('Section failed, using fallback:', handle);

      try {
        const res = await fetch(`/products/${handle}.js`);
        const product = await res.json();
        container.insertAdjacentHTML(
          'beforeend',
          `<li class="grid__item">${generateProductCard(product)}</li>`
        );
      } catch (err) {
        console.error('Product fallback failed:', err);
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', loadWishlist);

  } catch(e) { console.error(e); }
})();
})();
